export enum McpServerAuthenticationType {
    Unauthenticated = 0,
    KeyBased = 1,
}

export interface McpServerDto {
    id: string;
    name: string;
    serverUrl: string;
    authenticationType: McpServerAuthenticationType;
    credential?: string | null;
    credentialHeaderName?: string | null;
    agentNames: string[];
}

export interface McpServerTestConnectionDto {
    serverUrl: string;
    authenticationType: McpServerAuthenticationType;
    credential?: string | null;
    credentialHeaderName?: string | null;
}

export interface McpServerTestConnectionResultDto {
    success: boolean;
    message: string;
}

export interface AiAgentMcpServerDto {
    id: string;
    mcpServerId: string;
    name: string;
    serverUrl: string;
    authenticationType: McpServerAuthenticationType;
}
